import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=289bb454&scoped=true&"
import script from "./ClientForm.vue?vue&type=script&lang=js&"
export * from "./ClientForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=289bb454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bb454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VueCarousel }  from '@/components'
import { VueDatePicker }  from '@/components'
import { VueImageUpload }  from '@/components'
import { VueSelect }  from '@/components'
installComponents(component, {VBtn,VCard,VCardText,VCol,VExpandTransition,VFooter,VHover,VIcon,VImg,VResponsive,VRow,VSelect,VSwitch,VTextField,VTextarea,VueCarousel,VueDatePicker,VueImageUpload,VueSelect})


/* vuetify-loader */
import installIcons from "!../../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiAccount } from '@mdi/js';
import { mdiAccountBoxOutline } from '@mdi/js';
import { mdiAccountGroupOutline } from '@mdi/js';
import { mdiAccountMultipleOutline } from '@mdi/js';
import { mdiArrowDownBoldCircleOutline } from '@mdi/js';
import { mdiArrowUpBoldCircleOutline } from '@mdi/js';
import { mdiBriefcase } from '@mdi/js';
import { mdiCalendarMonthOutline } from '@mdi/js';
import { mdiChartBar } from '@mdi/js';
import { mdiClose } from '@mdi/js';
import { mdiDomain } from '@mdi/js';
import { mdiFileImageOutline } from '@mdi/js';
import { mdiFlagOutline } from '@mdi/js';
import { mdiGenderMaleFemale } from '@mdi/js';
import { mdiInformationOutline } from '@mdi/js';
import { mdiMapMarkerOutline } from '@mdi/js';
import { mdiPhoneSettingsOutline } from '@mdi/js';
import { mdiSwapHorizontal } from '@mdi/js';
import { mdiUpload } from '@mdi/js';
import { mdiWeb } from '@mdi/js';
installIcons(component, {mdiAccount,mdiAccountBoxOutline,mdiAccountGroupOutline,mdiAccountMultipleOutline,mdiArrowDownBoldCircleOutline,mdiArrowUpBoldCircleOutline,mdiBriefcase,mdiCalendarMonthOutline,mdiChartBar,mdiClose,mdiDomain,mdiFileImageOutline,mdiFlagOutline,mdiGenderMaleFemale,mdiInformationOutline,mdiMapMarkerOutline,mdiPhoneSettingsOutline,mdiSwapHorizontal,mdiUpload,mdiWeb})
